import Map from '../lib/Map.js';

export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        let latitude = ele.getAttribute('data-latitude');
        let longitude = ele.getAttribute('data-longitude');
        const isFullscreen = ele.getAttribute('data-fullscreen') === 'true';

        let selectedRadius = ele.getAttribute('data-radius');

        let mapOptions = {};
        if (isFullscreen) {
            mapOptions = {
                dragging: false,
                touchZoom: false,
                scrollWheelZoom: false,
                doubleClickZoom: false,
                tap: false,
                closePopupOnClick: false,
                keyboard: false,
                zoomControl: false,
            };
        } else {
            mapOptions = {
                dragging: false,
                touchZoom: false,
                scrollWheelZoom: false,
                doubleClickZoom: false,
                tap: false,
                closePopupOnClick: false,
                keyboard: false,
                zoomControl: false,
            };
        }
        mapOptions.onLoad = initMap;
        mapOptions.onClick = function() {};

        const map = new Map(ele, mapOptions);
        ele.widget = map; // FIXME
        map.init();

        if (isFullscreen) {
            radio('geo-widget-fullscreen-dismissed').subscribe(
                handleFullscreenDismissed
            );
            radio('geo-position-changed-from-filters-fullscreen').subscribe(
                handleLocationChanged
            );
        } else {
            radio('geo-position-changed-from-filters').subscribe(
                handleLocationChanged
            );
            radio('geo-radius-changed-from-filters').subscribe(
                handleRadiusChanged
            );
        }

        function handleFullscreenDismissed() {
            if (isFullscreen) {
                radio(
                    'geo-position-changed-from-filters-fullscreen'
                ).unsubscribe(handleLocationChanged);
                radio('fullscreen-geo-widget-dismissed').unsubscribe(
                    handleFullscreenDismissed
                );
            }
        }

        ele.addEventListener('click', handleMapClicked);

        function initMap() {
            if (latitude && longitude) {
                setLocationInMap(latitude, longitude, selectedRadius);
            }
        }

        function handleLocationChanged(lat, lng, radius) {
            selectedRadius = radius || selectedRadius;
            if (lat && lng) {
                latitude = lat;
                longitude = lng;
                setLocationInMap(lat, lng, selectedRadius);
            } else {
                map.clearMarkerAndRadius();
            }
        }

        function setLocationInMap(lat, lng, selectedRadius) {
            if (selectedRadius) {
                map.setMarkerAndRadius([lat, lng], selectedRadius);
            } else {
                map.setMarkerAndPan([lat, lng]);
            }
        }

        function handleRadiusChanged(radius) {
            selectedRadius = radius;
            map.setRadiusAndZoom(radius);
        }

        function handleMapClicked() {
            radio('geo-map-clicked').broadcast();
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/geoMap.js